<template>
  <div id="guardian-task-view" class="w-full" v-if="isCardActiveLocal">
    <div class="vx-row">
      <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
        <user-details :loading="loadingDetails" :userDetails="userDetails" :myTime="userDetailsObject.timeSpentAvarageStudent" :avgTime="userDetailsObject.timeSpentAvarageClass" :radialData="[userDetailsObject.scoreAvarageStudent,userDetailsObject.scoreAvarageClass]"/>
      </div>
    </div>
    <div class="flex mb-2" style="justify-content: space-between;">
      <div class="flex" style="align-items: center;">
        <h4 style="margin-bottom: 0;">Markable Tasks</h4>
      </div>
      <vx-input-group class="input-group-with-input-for-filtering ml-4" style="">
        <template slot="prepend">
          <div class="prepend-text ">
            <span><feather-icon class="pt-1" icon="SearchIcon" svg-classes="stroke-current h-5 w-5"></feather-icon></span>
          </div>
        </template>

        <vs-input class="dashboard-filter-input" placeholder="Search here..." v-model="taskFilterText"/>
      </vx-input-group>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
        <div v-if="!loadingDataCards" class="data-card-container flex" v-dragscroll @dragscrollstart="dragScollStart" @dragscrollend="dragScollEnd">
          <div v-for="(task, index) in markableTasks" :key="index" >
            <data-card :id="`Task-${task.id}`" :smallText="true" class="mx-2" type="Task" @handleClick="selectedTask(task)" :title="task.name" :myTime="task.myTime" :avgTime="task.avgTime" :radialData="task.radialData"/>
          </div>
        </div>
        <div v-if="loadingDataCards" class="vx-row data-card-container">
          <div class="vx-col w-full mb-3" style="padding-left: 0; padding-right: 0;">
            <data-card-skeleton :count="4"/>
          </div>
        </div>
      </div>
    </div>
    <div class="flex mb-4" style="justify-content: space-between;">
      <div class="flex" style="align-items: center;">
        <h4 style="margin-bottom: 0;">Tasks</h4>
      </div>
      <vx-input-group class="input-group-with-input-for-filtering ml-4" style="">
        <template slot="prepend">
          <div class="prepend-text ">
            <span><feather-icon class="pt-1" icon="SearchIcon" svg-classes="stroke-current h-5 w-5"></feather-icon></span>
          </div>
        </template>

        <vs-input class="dashboard-filter-input" placeholder="Search here..." v-model="taskFilterText"/>
      </vx-input-group>
    </div>
    <div class="vx-row ">
      <div class="vx-col w-full">
        <task-list :isLoading="taskListLoading" :taskList="tasks" :count="4" ></task-list>
      </div>
    </div>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import DataCard from './DataCard.vue'
import UserDetails from './UserDetails.vue'
import CustomSkeleton from './CustomSkeleton.vue'
import DataCardSkeleton from './DataCardSkeleton.vue'
import TaskList from './TaskList.vue';
export default {
  name: "Tasks",
  components: {
    vSelect,
    DataCard,
    UserDetails,
    CustomSkeleton,
    DataCardSkeleton,
    TaskList,
  },
  props: {
    isCardActive: {
      type: Boolean,
      required: true
    },
    userDetails:{
      type:Object,
      required: true
    },
    listOfStudentsForDropdown: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      loadingDetails:true,
      loadingDataCards:true,
      loadingCharts:true,
      tasks: [],
      originalTasks: [],
      taskFilterText: "",
      taskListLoading:true,
      dragging: false,
      userDetailsObject:{},
      markableTasks:[],
    };
  },
  watch: {
    isCardActive: function(val) {
      var self = this;
      if(val){
        self.fetchUserDetails();
        self.getTasks();
        localStorage.setItem("Teacher_Position",JSON.stringify(self.userDetails));
        localStorage.setItem("Active_Card","7");
      }
    },
    taskFilterText: function(val) {
      var self = this;
      if(val) {
        self.tasks = self.originalTasks.filter(function(x) { return x.name.toLowerCase().includes(val.toLowerCase()) });
      } else {
        self.tasks = self.originalTasks;
      }
    }
  },
  computed: {
    isCardActiveLocal: {
      get() {
        return this.isCardActive;
      },
      set(val) { }
    },
  },
  methods: {
    getTasks() {
      var self = this;

      self.loadingDetails = true;
      self.loadingDataCards = true;
      self.loadingCharts = true;

      var onSuccess = function(response) {
        self.tasks = [];
        self.markableTasks = [];
        response.data.forEach(element => {
          self.tasks.push({
            id:element.taskId,
            typeId:element.taskTypeId,
            name: element.taskName,
            completed:element.completed,
            myTime:element.timeSpentAvgStudent,
            avgTime:element.timeSpentAvgClass,
            radialData: [element.scoreAvgStudent, element.scoreAvgClass]
          });
          var markableTasks = [3,6,8,9,14];
          if(markableTasks.includes(element.taskTypeId)){
            self.markableTasks.push({
              id:element.taskId,
              typeId:element.taskTypeId,
              name: element.taskName,
              completed:element.completed,
              myTime:element.timeSpentAvgStudent,
              avgTime:element.timeSpentAvgClass,
              radialData: [element.scoreAvgStudent, element.scoreAvgClass]
            });
          }
        });

        self.originalTasks = self.tasks;
      };

      var onFinally = function() {
        self.loadingDataCards = false;
        self.loadingCharts = false;
        self.taskListLoading = false;
      };
      self.$ajaxGet(self,`TeacherDashboard/GetStudentTaskAvg?studentId=${self.userDetails.selectedStudent.studentId}&classroomId=${this.userDetails.selectedClassroom.classroomId}&moduleId=${this.userDetails.selectedTopic.id}`,onSuccess, onFinally);
    },
    selectedTask(task){
      if (!this.dragging) {
        this.$emit('selectedTask', task);
        this.userDetails.selectedTask = task;
      }
    },
    dragScollStart(){
      this.dragging = false;
    },
    dragScollEnd(){
      this.dragging = true;

      setTimeout(() => {
        this.dragging = false;
      }, 50);
    },
    fetchUserDetails() {
      var self = this;
      this.loadingDetails = true;
      var onSuccess = response =>{
        self.userDetailsObject = response.data;
        self.loadingDetails = false;
      }
      var onFinally = response =>{
        self.loadingDetails = false;
      }
      self.$ajaxGet(self, `TeacherDashboard/UserDetails?studentId=${self.userDetails.selectedStudent.studentId}&classroomId=${this.userDetails.selectedClassroom.classroomId}&moduleCategoryId=${this.userDetails.selectedModule.moduleCategoryId}&moduleId=${this.userDetails.selectedTopic.id}`, onSuccess, onFinally);
    },
  },
  created() {
    
  },
  mounted() {
  }
};
</script>